<template>
  <div class="">
    <select dir="rtl" v-model="owner">
      <option v-for="option in dropdownAdminsNames" :key="option">{{option}}</option>
    </select>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TableCellOwner',
  props: ['payload'],
  data () {
    return {
      owner: this.payload.owner
    }
  },
  computed: {
    ...mapGetters('admins', ['dropdownAdminsNames'])
  },
  watch: {
    owner (newVal) {
      this.$network_utils.updateAlert({ id: this.payload.id, owner: newVal }).then(() => {
        this.$utils.emit('show_toast', { text: 'success' })
      })
    }
  }
}
</script>
